/**
 * @constant {Object} PortalApiUrls
 * @description Contains all admin-related API endpoint URLs used throughout the application.
 */
export const PortalApiUrls = Object.freeze({
  GET_USER_PROFILE: "/user/customer/profile/",
  UPDATE_USER_PROFILE: "/user/customer/profile/",
  REGISTER_FCM_TOKEN: "/user/fcm_token/",
  DELETE_FCM_TOKEN: "/user/fcm_token/",
  GET_ORGANIZATION_TYPE: "/company/choices/organization_type/",
  CREATE_COMPANY: "/company/customer/",
  UPDATE_COMPANY: "/company/customer/",
  GET_COMPANY_PROFILE: "/company/customer/",
  GET_CATEGORIES: "/category/",
  SEARCH_CATEGORIES: "/category/search/",
  UPDATE_COMPANY_CATEGORIES: "/company/customer/category/",
  UPDATE_BID_CATEGORIES: "/category/customer/bid/",
  GET_STATES: "/global-places/states/",
  GET_CITIES: "/global-places/cities/",
  RETRIEVE_CITY: "/global-places/cities/",
  CREATE_ADDRESS: "/company/customer/address/",
  DELETE_ADDRESS: "/company/customer/address/",
  GET_CERTIFICATE_TYPE: "/company/choices/certificate_type/",
  CREATE_CERTIFICATE: "/company/customer/certificate/",
  DELETE_CERTIFICATE: "/company/customer/certificate/",
  CHANGE_PASSWORD: "/user/change_password/",
  GET_BID_TYPE: "/bid/choices/",
  CREATE_BID: "/bid/customer/",
  CLONE_BID: "bid/customer/clone/",
  BID_ADD_PRODUCT: "/product/customer/bid/",
  BID_PRODUCTS_LIST: "/product/customer/bid/",
  BID_EDIT_PRODUCT: "/product/customer/bid/",
  BID_DELETE_PRODUCT: "/product/customer/bid/",
  CREATED_LIST_BIDS: "/bid/customer/",
  INVITED_BID_LIST: "/bid/invited/customer/",
  RELATED_BID_LIST: "/bid/related/customer/",
  ADD_QUESTION: "/bid/question/customer/",
  DELETE_QUESTION: "/bid/question/customer/",
  UPLOAD_DOCUMENT: "/bid/customer/document/",
  DELETE_DOCUMENT: "/bid/customer/document/",
  RETRIEVE_CREATED_BID: "/bid/customer/",
  RETRIEVE_INVITED_BID: "/bid/invited/customer/",
  UPDATE_BID: "/bid/customer/",
  BID_SET_DATE: "/bid/customer/set_date/",
  CREATE_AMENDMENT: "/bid/customer/amendment/",
  CREATE_ORDER: "/payment/customer/order/",
  VERIFY_PAYMENT: "/payment/customer/verify/",
  CANCEL_BID: "/bid/customer/cancel/",
  SEARCH_BIDS: "/bid/customer/search/",
  SEND_INVITE: "/bid/customer/invite/",
  INVITE_ACTION: "/bid/invited/customer/action/",
  UPDATE_ANSWER: "/bid/question/customer/answer/",
  PARTICIPANTS_LIST: "/bid/customer/participant/",
  REVOKE_PARTICIPANT: "/bid/customer/revoke/",
  UNDO_PARTICIPANT_REVOCATION: "/bid/customer/revoke/undo/",
  COMPANY_LIST: "/company/customer/list/",
  BID_SAMPLE_ACTION: "/bid/customer/sample/action/",
  SEND_RELATED_REQUEST: "/bid/related/customer/request/",
  RETRIEVE_COMPANY_DETAILS: "/company/customer/",
  BID_INVITED_REQUESTS: "/bid/related/customer/requested/",
  REMARK: "/bid/invited/customer/remark/",
  PREVIOUS_BID: "/bid/customer/previous/",
  DELETE_BID_REQUEST: "/bid/related/customer/request/",
  SET_LIVE_DATES: "/bid/customer/set_date/",
  LIVE_BID_LIST_FOR_BUYER: "/bid/live/customer/",
  LIVE_BID_LIST_FOR_SUPPLIER: "/bid/live/customer/invited/",
  LIVE_BID_PRODUCTS_BUYER: "/bid/live/customer/product/",
  LIVE_BID_PRODUCTS_SUPPLIER: "/bid/live/customer/product/invited/",
  PLACE_A_BID: "/bid/live/customer/place_bid/",
  LIVE_BID_BIDDERS: "/bid/result/customer/participant/",
  LIVE_BID_PRODUCT_FOR_AWARD: "/bid/result/customer/product/",
  LIVE_BID_AWARD_BUYER: "/bid/result/customer/award/",
  LIVE_BID_CENCEL_PRODUCT: "/bid/result/customer/product/cancel/",
  LIVE_BID_LETTER_OF_INTENT_FOR_BUYER: "/bid/result/letter/",
  LIVE_BID_LETTER_OF_INTENT_FOR_SUPPLIER: "/bid/result/letter/invited/",
  LIVE_BID_RESULT_FOR_SUPPLIER: "/bid/result/customer/invited/",
  BID_FEEDBACK: "/feedback/bid/",
  RETRIEVE_FEEDACK: "/feedback/bid/",
  RETRIVE_COMPANY_REVIEWS: "/feedback/company/",
  START_CHAT_WITH_BUYER: "/chat/channel/",
  SEND_CHAT_MESSAGE: "/chat/channel/",
  GET_MESSAGE_LIST: "/chat/channel/",
  GET_CHAT_LIST: "/chat/channel/",
  MARK_MESSAGE_READ: "/chat/channel/",
  PORTAL_DASHBOARD: "/dashboard/customer/",
  GET_TEAM_LIST: "/user/customer/team/",
  ADD_TEAM_MEMBER: "/user/customer/team/",
  DEACTIVATE_MEMBER: "/user/customer/team/",
  RETRIVE_MEMBER: "/user/customer/team/",
  MISSING_DATA_REQUEST: "/support/customer/missing_data_request/",
  BID_PRICE_AMOUNT: "/payment/amount/",
  BID_CREATE_ORDER: "/payment/customer/order/",
  BID_VERIFY_PAYMENT: "/payment/customer/verify/",
  CUSTOMER_SUPPORT_TICKET: "/support/customer/ticket/",
});
